import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { actions as appActions } from '../actions/app';
import { actions as authActions } from '../actions/auth';
import { actions as assetsActions } from '../actions/assets';
import { actions as clipperMovieActions } from '../actions/clipperMovie';
import { actions as contentActions } from '../actions/content';
import LuciPropTypes from '../propTypes/';
import SidebarState from '../constants/sidebarState';
import SideBar from '../components/SideBar/SideBar';
import ClipperSidebarContent from '../components/Clipper/ClipperSidebarContent';
import { Container } from '../styled-components/Layout';
import ClipperTemplatesSelection from '../components/Clipper/ClipperTemplatesSelection';
import ClipperMovieSelection from '../components/Clipper/ClipperMovieSelection';
import ClipperTemplateEditor from '../components/Clipper/ClipperTemplateEditor';
import ClipperMovie from '../components/Clipper/ClipperMovie';
import DataEngine from '../../public/js/de';
import { Requestor, Replier } from '../../public/js/de.msg.request-reply';
import FullScreenOverlay from '../components/FullScreenOverlay';
import PublishingDialog from '../components/PublishingDialog';
import ClipperMode from '../constants/clipperMode';

const Content = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  position: relative;
  overflow-y: auto;
  height: 100%;
`;

const OverlayText = styled.div`
  font-size: 6rem;
  text-align: center;
  line-height: 6rem;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const LeftPanel = styled.div`
  flex: 1;
  flex-basis: 50%;
  border-right: 3px solid #ececec;
  position: relative;
`;

const RightPanel = styled.div`
  background-color: rgb(215, 214, 214);
  flex: 1;
  flex-basis: 50%;
  position: relative;
`;

class ClipperLayout extends Component {
  constructor(props) {
    super(props);

    this.defaultTemplatesText = 'Double click a movie to open in viewer.';

    this.requestor = null;
    this.replier = null;
    const sessionId = props.params.sessionId || props.sessionId;
    if (sessionId) {
      this.setUpMessaging(sessionId);
    }

    this.state = {
      movieSelected: false,
      closeOverlayVisible: false,
      inserted: false, // controls whether main luci will redirect back to the assets screen
      publishingDialogVisible: false,
      mode: ClipperMode.NORMAL
    };
  }

  UNSAFE_componentWillMount() {
    this.props.changeSidebarState(SidebarState.RIGHT_ONLY);
    if (this.props.params.user) {
      this.props.login(this.props.params.user, false, true);
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const userLoggedIn = nextProps.authenticated;
    const userChanged = this.props.userId !== nextProps.userId;
    const contextsPopulated = nextProps.contextList && nextProps.contextList.length > 0;

    if (!nextProps.contextsLoading && (userChanged && userLoggedIn && !contextsPopulated)) {
      this.props.getContexts(nextProps.userId);
      this.props.getCategories('template');
      this.props.getContentFilterOptions(nextProps.userId, 'video');
      this.props.getAssetFilterOptions(nextProps.userId, 'template');
    }
  }

  componentWillUnmount() {
    this.requestor.request({
      type: 'CLIPPER_CLOSED',
      redirect: this.state.inserted
    });

    if (this.de) {
      this.de.close();
    }
  }

  setUpMessaging = sessionId => {
    const bucket = 'luci.messaging';
    this.de =
      window.location.protocol === 'https:'
        ? new DataEngine({ path: 'dataengine/', bucket })
        : new DataEngine({ host: window.location.hostname, bucket, port: 4300 });
    this.de.connection.onConnect = () => {
      this.requestor = new Requestor(this.de, `luci.messaging.${sessionId}-luci`, 10000);
      this.replier = new Replier(this.de, `luci.messaging.${sessionId}-clipper`);
      console.log(
        `Data engine connected to ${window.location.hostname}:4300, 'luci.messaging.${sessionId}'`
      );
      this.replier.onMessage = (msg, callback) => {
        switch (msg.type) {
          case 'INITIALIZE_CLIPPER':
            this.setState({ mode: msg.mode || ClipperMode.NORMAL });
            return callback(null, {
              type: 'CLIPPER_INITIALIZED'
            });
          default:
            break;
          // return callback(`Unknown message type: ${msg.type}`);
        }
      };
      window.onbeforeunload = () => {
        this.requestor.request({
          type: 'CLIPPER_CLOSED',
          redirect: this.state.inserted
        });
      };
    };
  };

  getLeftPanel = () => {
    if (this.props.templateSelected) {
      return <ClipperTemplateEditor />;
    }
    return <ClipperTemplatesSelection enabled={this.state.movieSelected} />;
  };

  getRightPanel = () => {
    if (this.state.movieSelected) {
      return <ClipperMovie />;
    }

    return <ClipperMovieSelection onConfirmAssetSelected={this.movieSelected} />;
  };

  insertToScript = () => {
    this.setState({ inserted: true });
    this.requestor
      .request({
        type: 'INSERT_FROM_CLIPPER',
        mosObjects: this.props.timelineGraphics
      })
      .then(reply => {
        if (reply.type === 'INSERT_CONFIRMED') {
          this.setState({ closeOverlayVisible: true });
          window.close();
        }
        return Promise.resolve();
      })
      .catch(err => {
        console.log('Sending message to data engine failed.');
        console.log(err);
      });
  };

  movieSelected = res => {
    this.setState({ movieSelected: true });
    this.requestor.request({
      type: 'MOVIE_SELECTED',
      asset: res
    });
    this.props.loadMovie(res.assetUrl, res.filePath, res.frameRate);
    this.props.getAssets();
  };

  publish = () => {
    this.setState({ publishingDialogVisible: true });
  };

  render() {
    return (
      <Container>
        <FullScreenOverlay visible={this.state.closeOverlayVisible}>
          <OverlayText>CLOSE CLIPPER TO RETURN BACK TO LUCI</OverlayText>
        </FullScreenOverlay>
        <SideBar fixed right footerHeight="0rem">
          <ClipperSidebarContent
            movieSelected={this.state.movieSelected}
            insertToScript={this.state.mode !== ClipperMode.NORMAL ? null : this.insertToScript}
            publish={this.publish}
          />
        </SideBar>
        <Content>
          <LeftPanel>{this.getLeftPanel()}</LeftPanel>
          <RightPanel>{this.getRightPanel()}</RightPanel>
          {this.state.publishingDialogVisible && (
            <PublishingDialog
              isClipperAsset
              isOpen
              closeDialog={() => this.setState({ publishingDialogVisible: false })}
            />
          )}
        </Content>
      </Container>
    );
  }
}

ClipperLayout.defaultProps = {
  params: {
    user: null,
    sessionId: null
  },
  sessionId: null,
  timelineGraphics: []
};

ClipperLayout.propTypes = {
  changeSidebarState: PropTypes.func.isRequired,
  loadMovie: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  params: PropTypes.shape({
    user: PropTypes.string,
    sessionId: PropTypes.string
  }),
  getContexts: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  // eslint-disable-next-line
  authenticated: PropTypes.bool.isRequired,
  // eslint-disable-next-line
  contextList: LuciPropTypes.ContextList.isRequired,
  getAssets: PropTypes.func.isRequired,
  sessionId: PropTypes.string,
  timelineGraphics: PropTypes.arrayOf(LuciPropTypes.TimelineGraphic),
  getAssetFilterOptions: PropTypes.func.isRequired,
  getContentFilterOptions: PropTypes.func.isRequired,
  templateSelected: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  userId: state.auth.user.userId,
  authenticated: state.auth.authenticated,
  contextList: state.assets.contextList,
  sessionId: state.auth.user.sessionId,
  timelineGraphics: state.clipperMovie.timelineGraphics,
  templateSelected: state.asset.selectedAssetId != null && state.asset.selectedAssetId !== ''
});

const mapActionCreators = {
  changeSidebarState: appActions.changeSidebarState,
  loadMovie: clipperMovieActions.loadVideo,
  login: authActions.login,
  getContexts: assetsActions.getContexts,
  getCategories: assetsActions.getCategories,
  getAssets: assetsActions.getAssets,
  getAssetFilterOptions: assetsActions.getFilterOptions,
  getContentFilterOptions: contentActions.getFilterOptions
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(ClipperLayout);



// WEBPACK FOOTER //
// ./app/layouts/ClipperLayout.js